export const priceImpactDefault = 'text-token-gray-700';
export const priceImpactNegative = 'text-token-red-900';
export const priceImpactPositive = 'text-token-green-1000';
